//DefaultTable

import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Button, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import { FaBox } from 'react-icons/fa';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'paletizado_Id';

export default function Paletizados_Table(props) {
    const [pageSize, setPageSize] = React.useState(25);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            sort: 'desc',
        },
    ]);
    const intl = useIntl();

    const getPaletasTotales = () => {
        console.log("rows.count", rows.length);
        return rows.length;
    }
    const getCajasTotales = () => {
        const sum = rows.reduce((accumulator, object) => {
            return accumulator + object.cajasPorPaleta;
        }, 0);
        return sum;
    }

    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'createdDate',
            headerName: intl.formatMessage({ id: 'Fecha de creación' }),
            editable: false,
            width: 120,
            renderCell: (params) => {
                //return params.row['createdDate'].slice(0, 10)
                //return new Date(params.row['fechaDeEmpaque']).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
                return new Date(params.row['createdDate']).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit', hour: 'numeric', minute: 'numeric' }).replace(",","");
            }

        },
        {
            field: 'etiquetaCore',
            headerName: intl.formatMessage({ id: 'EtiquetaCore' }),
            editable: false,
            width: 155,
        },
        //{
        //    field: 'tipoFruta',
        //    headerName: intl.formatMessage({ id: 'Tipo de fruta' }),
        //    editable: false,
        //    width: 100,
        //},
        {
            field: 'calibre',
            headerName: intl.formatMessage({ id: 'Calibre' }),
            editable: false,
            width: 80,
        },
        {
            field: 'cajasPorPaleta',
            headerName: intl.formatMessage({ id: 'CajasPorPaleta' }),
            editable: false,
            width: 80,
        },
        {
            field: 'codigoTMU',
            headerName: intl.formatMessage({ id: 'Código TMU' }),
            editable: false,
            width: 200,
        },
        {
            field: 'fechaDeCosecha',
            headerName: intl.formatMessage({ id: 'Fecha de cosecha' }),
            editable: false,
            width:115,
            renderCell: (params) => {
                //return params.row['fechaDeCosecha'].slice(0, 10)
                return new Date(params.row['fechaDeCosecha']).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
            }
        },
        {
            field: 'fechaDeEmpaque',
            headerName: intl.formatMessage({ id: 'Fecha de empaque' }),
            editable: false,
            width: 115,
            renderCell: (params) => {
                //return params.row['fechaDeEmpaque'].slice(0, 10)
                return new Date(params.row['fechaDeEmpaque']).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit' })
            }
        },
        {
            field: 'finca',
            headerName: intl.formatMessage({ id: 'Finca' }),
            editable: false,
            width: 115,
        },
        {
            field: 'productNetWeight',
            headerName: intl.formatMessage({ id: 'ProductNetWeight' }),
            editable: false,
            width: 75,
        },
        {
            field: 'productTaraWeight',
            headerName: intl.formatMessage({ id: 'ProductTaraWeight' }),
            editable: false,
            width: 75,
        },
        {
            field: 'rechazo',
            headerName: intl.formatMessage({ id: 'Rechazo' }),
            editable: false,
            width: 75,
        },
        {
            field: 'comentarios',
            headerName: intl.formatMessage({ id: 'Comentarios' }),
            editable: false,
            width: 175,
        },
        //{
        //    field: 'paletizados',
        //    headerName: '',
        //    sortable: false,
        //    editable: false,
        //    filterable: false,
        //    align: 'center',
        //    width: 160,
        //    renderCell: (params) => {
        //        return (
        //            <Button className="DarkTealButton" onClick={() => {
        //                window.location.href = '/Paletizados/' + params.row[keyField] + '/Paletizados'
        //            }}>
        //                <LocalShippingOutlinedIcon /> {intl.formatMessage({ id: 'Paletizados' })}
        //            </Button>
        //        )
        //    },
        //},
        {
            field: 'actions',
            headerName: '',
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 120,
            renderCell: (params) => {
                return (
                    <div>
                        <Tooltip title="Editar">
                            <IconButton className='DarkBlueButton GridButton' onClick={() => {
                                props.edit_onclick(params.row[keyField])
                            }}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Eliminar">
                            <IconButton className='RedButton GridButton' onClick={() => {
                                props.delete_onclick(params.row[keyField])
                            }}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                )
            },
        },

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        paletizado_Id: false,
    });
    return (
        <div>
            <Toolbar>
                <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                    {/*<div className="col col-md-3"></div>*/}
                    <div className="col col-md-3">
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#25675D', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><FaPallet style={{ color: '#52877D' }} /></h1>
                                    <div>
                                        Paletas
                                        <CardTitle tag="h4">
                                            {getPaletasTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        {/*<h3>Paletas totales: {getPaletasTotales()}   Cajas Totales: {getCajasTotales()}</h3>*/}
                    </div>
                    <div className="col col-md-3">
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#B8895F', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><FaBoxes style={{ color: '#C6A27E' }} /></h1>
                                    <div>
                                        Cajas
                                        <CardTitle tag="h4">
                                            {getCajasTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        {/*<h3>Paletas totales: {getPaletasTotales()}   Cajas Totales: {getCajasTotales()}</h3>*/}
                    </div>
                </div>
                {/*<Button className="AddButton" style={{ whiteSpace: 'nowrap' }} onClick={() => {*/}
                {/*    props.add_onclick()*/}
                {/*}}><AddIcon /> Agregar</Button>*/}
            </Toolbar>
            <Box sx={{
                height: 600,
                width: '100%',
                '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle': {
                    fontSize: '13px', // Change this value to adjust the font size
                },
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[25, 50]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}

                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
